import {PulseAnalyticsServiceInterface} from '@/src/ports/services/analytic-service'
import {PulseEventMap} from '@/src/core/domain/services/analytic/types'

declare global {
  interface Window {
    PingTrack: {
      identify(payload: unknown): void
      track(name: string, payload: unknown): void
      trackPurchase(payload: unknown): void
    }
  }
}

export class PulseAnalyticService implements PulseAnalyticsServiceInterface {
  async track(name: string, payload: unknown): Promise<void> {
    if (name == PulseEventMap.OrderPurshase) {
      this.trackPurshase(payload)
    } else {
      window.PingTrack.track(name, payload)
    }
  }

  async trackPurshase(payload: unknown) {
    window.PingTrack.trackPurchase(payload)
  }

  async identify(payload: unknown) {
    window.PingTrack.identify(payload)
  }
}
